import React, { useState } from 'react';

import PasswordStrenth from '../../../../../components/UI/PasswordStrength/PasswordStrength';

const Credentials = props => {
    const [passwordVisible, setPasswordVisible] = useState(false);
    
    return (
        <form onSubmit={event => props.createPasswordHandler(event)} autoComplete="false">
            <div className="form-group form-material floating" data-plugin="formMaterial">
                <div className="input-group">
                    <div className="input-group-prepend">
                        <span className="input-group-text" style={{cursor: 'pointer'}} onClick={() => setPasswordVisible(!passwordVisible)}>
                            <i className={passwordVisible ? 'icon fa-eye' : 'icon fa-eye-slash'} aria-hidden="true"></i>
                        </span>
                    </div>
                    <div className="form-control-wrap">
                        <PasswordStrenth userPasswordChangeHandler={(password, isValid) => props.userPasswordChangeHandler(password, isValid)} inputProps={{type: passwordVisible ? 'text' : 'password', placeholder: 'Password'}} style={{position: 'absolute'}} />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <button type="submit" className="btn btn-block btn-raised btn-animate btn-animate-vertical btn-success btn-sm waves-effect waves-classic" disabled={!props.password}>
                    <span><i className="icon ti-check" aria-hidden="true"></i>&nbsp;Submit</span>
                </button>
            </div>
        </form>
    );
}

export default Credentials;